import React from 'react';
import { Container, SimpleGrid, Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { ContentCard } from '../../common';
import HoverMeasurements from '../../../assets/videos/hover_measurements.mp4';

const ExteriorContractorsMarketingAndSales: React.FC = () => (
  <Container maxW="1200px" px={500} mb={{ base: '72px', desktop: '152px' }}>
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      alignItems="center"
      spacing={{ base: 700, desktop: 900 }}
      mb={{ base: '72px', desktop: '150px' }}
    >
      <ContentCard
        maxW="xl"
        title="MARKETING"
        header="Help Homeowners See the Possibilities"
        topBody="Our collaborative 3D model not only helps homeowners visualize their project,
         it gets you all on the same page before the work starts. And fast, accurate measurements
          and estimates make for a simpler, more transparent process. All of which means even
          the most challenging projects feel possible."
      />
      <Container px={0} centerContent>
        <Box maxW="380px" maxH="560px">
          <StaticImage
            quality={100}
            placeholder="blurred"
            alt="marketing"
            src="../../../assets/images/exterior_contractors_marketing.png"
            objectFit="contain"
          />
        </Box>
      </Container>
    </SimpleGrid>
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      alignItems="center"
      spacing={{ base: 700, desktop: 900 }}
      mt={{ base: '72px', desktop: '150px' }}
    >
      <Container px={0} d={{ base: 'none', desktop: 'flex' }}>
        <Box w="481px" h="362px">
          <video
            src={HoverMeasurements}
            width="100%"
            height="100%"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={HoverMeasurements} type="video/mp4" />
          </video>
        </Box>
      </Container>
      <ContentCard
        maxW="xl"
        title="SALES"
        header="Work Smarter, Not Harder"
        topBody="Best-in-industry measurements, collaborative tools, and fast and accurate
        estimates make it easier to build your business while building better relationships
        with your customers."
      />
      <Container px={0} d={{ base: 'flex', desktop: 'none' }} centerContent>
        <Box maxW="480px" maxH="360px">
          <video
            src={HoverMeasurements}
            width="100%"
            height="100%"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={HoverMeasurements} type="video/mp4" />
          </video>
        </Box>
      </Container>
    </SimpleGrid>
  </Container>
);

export default ExteriorContractorsMarketingAndSales;
